import { createTrackingUtils } from "../index";
import { useCallback } from "react";
import useProfiler from "../../../hooks/useProfiler";

export const utils = createTrackingUtils({
  name: "flights_web_weekend_top_filter",
  defaultStage: 1,
  stages: {
    main: 1,
    ddot: 2,
    mdot: 3,
    meta: 4,
    solo: 5,
    apexOverlap: 6,
    us: 7,
    en: 8,
    overlap: 9
  },
  goals: {
    morning: 1,
    evening: 2,
    cabin: 3,
    budget: 4,
    clear: 5
  }
});

export default function useFlightsWebWeekendTopFilter() {
  const { isRountrip, isDesktop, isMeta, isSolo, isAmerican, isWeekendStay, isEnglish } = useProfiler();

  const trackStages = useCallback(() => {
    if (isDesktop()) utils.stages.ddot();
    if (!isDesktop()) utils.stages.mdot();
    if (isMeta()) utils.stages.meta();
    if (isSolo()) utils.stages.solo();
    if (isAmerican()) utils.stages.us();
    if (isEnglish()) utils.stages.en();
  }, [isDesktop, isMeta, isSolo, isAmerican, isEnglish]);

  const isVariant = useCallback(() => {
    if (isRountrip() && isWeekendStay()) {
      trackStages();
      return !!utils.trackWithDefaultStage();
    } else {
      return false;
    }
  }, [isRountrip, isWeekendStay, trackStages]);

  const overlap = useCallback(() => {
    if (isRountrip() && isWeekendStay()) utils.stages.overlap();
  }, [isRountrip, isWeekendStay]);

  const apexOverlap = useCallback(() => {
    if (isRountrip() && isWeekendStay()) utils.stages.apexOverlap();
  }, [isRountrip, isWeekendStay]);

  return { isVariant, goals: utils.goals, overlap, apexOverlap };
}
